import React, { useState, useEffect } from "react";
import { EnvironmentalDataContext } from "./context";

import { getEnvironmentalData } from "../services/services";

const EnvironmentalProvider = ({ children }) => {
  const [environmentalData, setEnvironmentalData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEnvironmental = async () => {
      const environmental = await getEnvironmentalData({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });
      setEnvironmentalData(environmental);
    };

    fetchEnvironmental();
  }, []);

  return (
    <EnvironmentalDataContext.Provider
      value={{ environmentalData, setEnvironmentalData, loading, error }}
    >
      {children}
    </EnvironmentalDataContext.Provider>
  );
};

export default EnvironmentalProvider;
